function l(l){return{scrollLeft:l.scrollLeft,scrollTop:l.scrollTop}}export{l as default};
